import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=3ad3e21f&scoped=true"
import script from "./AddressItem.vue?vue&type=script&lang=js"
export * from "./AddressItem.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles-new/city.sass?vue&type=style&index=0&id=3ad3e21f&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad3e21f",
  null
  
)

export default component.exports